import React, { useState, useRef } from "react";
import {
    Grid,
    Input,
    MenuItem,
    Select,
    InputLabel,
    Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import { yellow } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Radio from '@mui/material/Radio';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import Paper from "@mui/material/Paper";

const Transfer = ({
    airport, setAirport,
    flightNumber, setFlightNumber,
    hour, setHour,
    terminal, setTerminal,
    umService, setUmService,
    transfer, setTransfer,
    selectedCenter,
    title,
    isFormInvalid,
    readonly,
    comment, setComment
}) => {

    const handleTransferChange = (transfer) => {
        if (transfer == 0) {
            setUmService(0)
        }
        setTransfer(transfer);
    }

    const getCurrencyAsString = () => {
        switch (selectedCenter.currency) {
            case 1:
                return "€";
            case 2:
                return "£"
            case 3:
                return "$"
        }
    }

    return (
        <Paper elevation={3} className={"step-container"}>
            <Grid item xs={12}>
                <Typography sx={{ color: 'primary.main' }} fontSize={20} fontWeight={'bold'} marginBottom={2} align="left">
                    {title}
                </Typography>
                <Grid item xs={6}>
                    <FormControl error={(isFormInvalid && transfer == null)}>


                        {selectedCenter.currency == 2 ? <FormLabel>{`Transfer required? *(${getCurrencyAsString()}${selectedCenter.transferPrice ? selectedCenter.transferPrice : 0})`}</FormLabel>
                            : <FormLabel>{`Transfer required? *(${selectedCenter.transferPrice ? selectedCenter.transferPrice : 0} ${getCurrencyAsString()})`}</FormLabel>}




                        <RadioGroup row>
                            <FormControlLabel value={1} disabled={readonly} control={<Radio value={1} checked={transfer == 1} onChange={(e) => handleTransferChange(e.target.value)} />} label="Yes" />
                            <FormControlLabel value={0} disabled={readonly} control={<Radio value={0} checked={transfer == 0} onChange={(e) => handleTransferChange(e.target.value)} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormLabel htmlFor="departureFlightNumber">Estimated {title} Hour</FormLabel>
                    <br></br>
                    <TextField
                        id="time"
                        type="time"
                        disabled={readonly}
                        size="small"
                        defaultValue="07:30"
                        inputProps={{
                            step: 300, // 5 min
                        }}
                        sx={{ marginBottom: 7 }}
                        value={hour}
                        onChange={(e) => setHour(e.target.value)}
                    />
                </Grid>
                {transfer == 1 ? <>

                    <Grid item xs={12}>
                        <FormLabel>Airport</FormLabel>
                        <Select size="small" disabled={readonly} value={airport || 0} onChange={(e) => setAirport(e.target.value)} style={{ width: "100%", background: "white" }}>
                            <MenuItem value={0} sx={{ height: '35px' }}>{''}</MenuItem>
                            {selectedCenter.airports != null && selectedCenter.airports.filter(a => a.active).map((airport) => (
                                <MenuItem value={airport.id}>{airport.name}</MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <FormLabel htmlFor="FlightNumber">Flight Number</FormLabel>
                            <TextField
                                type="text"
                                size="small"
                                disabled={readonly}
                                className="form-control"
                                value={flightNumber}
                                onChange={(e) => setFlightNumber(e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormLabel htmlFor="Terminal">Terminal</FormLabel>
                            <TextField
                                type="text"
                                size="small"
                                disabled={readonly}
                                className="form-control"
                                name="terminal"
                                value={terminal}
                                onChange={(e) => setTerminal(e.target.value)} />
                        </Grid>



                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={(isFormInvalid && umService == null)}>

                            <Tooltip title="On arrival at the airport, please go to the LINES Meeting Point (after baggage claim) where a member of staff holding a LINES welcome sign will be waiting for you. The staff member will be wearing a LINES identity badge and a LINES T-shirt. Do not leave with any other person or take a taxi. Please do not delay in going to the Meeting Point. If your flight is delayed en route, please don't worry, we will be aware and meet you on arrival, whatever the time. There is a member of staff at the airport throughout the day. If you are traveling as an unaccompanied minor, our LINES staff member will contact the relevant member of airline staff to take charge of you. Please tell your airline that they will have a LINES identity card and another form of identification. You will be returned to the airport in good time for your return flight and helped to check in. We wish you a safe flight and look forward to meeting you.">
                                <InfoIcon color="primary" />
                            </Tooltip>
                            {selectedCenter.currency == 2 ? <FormLabel>{`UM Service *(${getCurrencyAsString()}${selectedCenter.umPrice ? selectedCenter.umPrice : 0} )`}</FormLabel> :

                                <FormLabel>{`UM Service *(${selectedCenter.umPrice ? selectedCenter.umPrice : 0} ${getCurrencyAsString()})`}</FormLabel>}
                            <RadioGroup row>
                                <FormControlLabel value={1} control={<Radio value={1} disabled={readonly} checked={umService == 1} onChange={(e) => setUmService(e.target.value)} />} label="Yes" />
                                <FormControlLabel value={0} control={<Radio value={0} disabled={readonly} checked={umService == 0} onChange={(e) => setUmService(e.target.value)} />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                </> : <></>}

                <Grid item xs={12}>
                    <FormLabel htmlFor="departureFlightNumber">{title} comment</FormLabel>
                    <TextField
                        id="outlined-multiline-flexible"
                        fullWidth
                        multiline
                        value={comment}
                        rows={3}
                        onChange={(e) => setComment(e.target.value)}
                        
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>

            </Grid>
        </Paper>)
}

export default Transfer